import {
  imprint,
  infoCenter,
  marketLocation,
  marketLocationForecast,
  marketLocationMasterData,
  marketLocationRevenueReport,
  optimizationGroups,
  root,
} from '@e2m-customer-portal/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useCurrentEnv } from '../use-env-settings/use-env-settings';
import { useMarketLocationId } from '../use-market-location-id/use-market-location-id';
import { useMarketLocationSync } from '../use-market-location/use-market-location';

interface Title {
  appTitle: string;
  pageTitle?: string;
  fullTitle: string;
}

export function useTitle(): Title {
  const [t] = useTranslation();
  const { pathname } = useLocation();
  const marketLocationId = useMarketLocationId();
  const [pageTitle, setPageTitle] = useState<string>();
  const { data: fetchedMarketLocation } = useMarketLocationSync(marketLocationId ?? '', {
    skip: marketLocationId == null || !marketLocation.match(pathname, { end: true }),
  });

  const updatePageTitle = (pt: string | undefined): void => {
    if (pt !== pageTitle) {
      setPageTitle(pt);
    }
  };

  switch (true) {
    case !!root.match(pathname, { end: true }):
      updatePageTitle(t('HEADER_MENU_ROOT'));
      break;
    case !!imprint.match(pathname, { end: true }):
      updatePageTitle(t('HEADER_MENU_IMPRINT'));
      break;
    case !!infoCenter.match(pathname, { end: true }):
      updatePageTitle(t('HEADER_MENU_INFO_CENTER'));
      break;
    case !!optimizationGroups.match(pathname, { end: true }):
      updatePageTitle(t('HEADER_MENU_OPTIMIZATION_GROUPS'));
      break;
    case !!marketLocation.match(pathname, { end: true }):
      if (fetchedMarketLocation) {
        updatePageTitle(fetchedMarketLocation.marketLocation.name);
      }
      break;
    case !!marketLocationForecast.match(pathname, { end: true }):
      updatePageTitle(t('SIDEBAR_MARKET_LOCATION_FORECAST'));
      break;
    case !!marketLocationMasterData.match(pathname, { end: true }):
      updatePageTitle(t('SIDEBAR_MARKET_LOCATION_MASTER_DATA'));
      break;
    case !!marketLocationRevenueReport.match(pathname, { end: true }):
      updatePageTitle(t('SIDEBAR_MARKET_LOCATION_REVENUE_REPORT'));
      break;
  }

  const env = useCurrentEnv();
  const appTitle = t('APP_TITLE', {
    env: env !== 'PROD' ? `[${env}]` : '',
  });
  const fullTitle = (pageTitle ? `${pageTitle} - ` : '') + appTitle;

  return {
    appTitle,
    pageTitle,
    fullTitle,
  };
}
